export const sliderOpen = (targetDomElement, time = 1000) => {
    targetDomElement.classList.add("opened");
    targetDomElement.style.transition = `${time}ms`;
    targetDomElement.style.height = `${targetDomElement.scrollHeight}px`;
};

export const sliderClose = (targetDomElement, time = 1000) => {
    targetDomElement.classList.remove("opened");
    targetDomElement.style.transition = `${time}ms`;
    targetDomElement.style.height = `0px`;
};

export const sliderToggle = (targetDomElement, time = 1000) => {
    if (targetDomElement.classList.contains("opened")) {
        sliderClose(targetDomElement, time);
    } else {
        sliderOpen(targetDomElement, time);
    }
};
